import React from 'react';
import PropTypes from 'prop-types';
import { Icons, Button } from 'sarsaparilla';

const defaultProps = {
  displayError: false
};

const propTypes = {
  toggle: PropTypes.func.isRequired,
  displayError: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.element)
};

const ValidationError = ({ displayError, children }) => {
  if (!displayError) {
    return null;
  }
  return (
    <div className="rec-notification-error">
      <span className="rec-notification-icon">
          <Icons.IconError className="rec-icon-error" />
      </span>
      <div className="rec-notification-body">
      <div className="rec-notification-title">Validation Errors:</div>
        {children}
      </div>
      <Button className="rec-notification-close">
          <Icons.IconClose className="rec-icon-close" />
      </Button>
    </div>
  );
};

ValidationError.propTypes = propTypes;
ValidationError.defaultProps = defaultProps;

export default ValidationError;
